import { UserApiBase } from '@/libs/apis/user/base';

export class UserUpdateDetailsApi extends UserApiBase {
  async saveDetails(email, phone) {
    return await super.post('update-details/', { email, phone });
  }
}
